import { useFetch } from '@api/services/utilsService/utilsApiService';
import { BASE_URL } from '@utils/common';
import { AccountsV2Response } from '../../../types/generated/pos';

export const useAccountApi = () => {
	return useFetch<AccountsV2Response>(`${BASE_URL}/v2/accounts`);
};
